var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tx_link"
  }, [_vm.txID ? [_vm.isXP ? _c('router-link', {
    attrs: {
      "to": _vm.xpURL
    }
  }, [_c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('fa', _vm._g({
          attrs: {
            "icon": "arrow-right",
            "color": "#c4c4c4"
          }
        }, on))];
      }
    }], null, false, 2440273853)
  }, [_c('div', [_c('p', [_c('span', {
    staticClass: "light"
  }, [_vm._v("UTXO was spent on")]), _vm._v(" " + _vm._s(_vm.chain) + " ")]), _c('p', [_c('span', {
    staticClass: "light"
  }, [_vm._v("Tx ID: ")]), _c('span', {
    staticClass: "monospace"
  }, [_vm._v(_vm._s(_vm.txID))])])])])], 1) : _c('a', {
    attrs: {
      "href": _vm.cURL
    }
  }, [_c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('fa', _vm._g({
          attrs: {
            "icon": "arrow-right",
            "color": "#c4c4c4"
          }
        }, on))];
      }
    }], null, false, 2440273853)
  }, [_c('div', [_c('p', [_c('span', {
    staticClass: "light"
  }, [_vm._v("UTXO was spent on")]), _vm._v(_vm._s(_vm.chain) + " ")]), _c('p', [_c('span', {
    staticClass: "light"
  }, [_vm._v("Tx ID: ")]), _c('span', {
    staticClass: "monospace"
  }, [_vm._v(_vm._s(_vm.txID))])])])])], 1)] : [_c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on;
        return [_c('fa', _vm._g({
          attrs: {
            "icon": "info-circle",
            "color": "#e4e4e4"
          }
        }, on))];
      }
    }])
  }, [_c('div', [_c('p', [_c('span', {
    staticClass: "light"
  }, [_vm._v("Unspent UTXO on")]), _vm._v(" " + _vm._s(_vm.chain) + " ")])])])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }